import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteAutoApplyApplicationDraftMutationVariables = Types.Exact<{
    input: Types.DeleteDraftManagementApplicationDraftInput;
}>;

export type DeleteAutoApplyApplicationDraftMutation = {
    __typename?: 'Mutation';
    draftManagementApplicationDraft: {
        __typename?: 'DraftManagementApplicationDraftMutations';
        delete?:
            | {
                  __typename?: 'DeleteDraftManagementApplicationDraftPayload';
                  applicationDraftId: string;
              }
            | null
            | undefined;
    };
};

export const DeleteAutoApplyApplicationDraftDocument = gql`
    mutation DeleteAutoApplyApplicationDraft($input: DeleteDraftManagementApplicationDraftInput!) {
        draftManagementApplicationDraft {
            delete(input: $input) {
                applicationDraftId
            }
        }
    }
`;
export type DeleteAutoApplyApplicationDraftMutationFn = Apollo.MutationFunction<
    DeleteAutoApplyApplicationDraftMutation,
    DeleteAutoApplyApplicationDraftMutationVariables
>;

/**
 * __useDeleteAutoApplyApplicationDraftMutation__
 *
 * To run a mutation, you first call `useDeleteAutoApplyApplicationDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutoApplyApplicationDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutoApplyApplicationDraftMutation, { data, loading, error }] = useDeleteAutoApplyApplicationDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAutoApplyApplicationDraftMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteAutoApplyApplicationDraftMutation,
        DeleteAutoApplyApplicationDraftMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        DeleteAutoApplyApplicationDraftMutation,
        DeleteAutoApplyApplicationDraftMutationVariables
    >(DeleteAutoApplyApplicationDraftDocument, options);
}
export type DeleteAutoApplyApplicationDraftMutationHookResult = ReturnType<
    typeof useDeleteAutoApplyApplicationDraftMutation
>;
export type DeleteAutoApplyApplicationDraftMutationResult =
    Apollo.MutationResult<DeleteAutoApplyApplicationDraftMutation>;
export type DeleteAutoApplyApplicationDraftMutationOptions = Apollo.BaseMutationOptions<
    DeleteAutoApplyApplicationDraftMutation,
    DeleteAutoApplyApplicationDraftMutationVariables
>;
